import React, { useState, useContext, useEffect } from 'react'
import { useParams, Link } from 'react-router-dom'
import styled from 'styled-components'
import { useLazyQuery } from '@apollo/client'
import Loader from '../_common/loader'
import AddedModal from '../SearchResults/uiComponents/addedModal'
import Context from '../../setup/context'
import { zonedTimeToUtc, format as dateFormat } from 'date-fns-tz'
import AddToShoppingListModal from '../_common/modals/AddToShoppingListModal'
import { GET_ITEM_PRICE } from 'setup/providerGQL'
import { anchorLink, buildSearchString, getRidOf__typename_generic } from 'pageComponents/_common/helpers/generalHelperFunctions'
import { GET_ITEM_DETAIL_PAGE_ITEM_INFO, GET_ACCESSORY_ITEMS_INFO } from 'setup/gqlQueries/gqlItemQueries'
import LocationsModal from '../_common/modals/LocationsModal'
import QuantityInput from 'pageComponents/_common/form/quantityInput'
import AirlineChip from 'pageComponents/_common/styledComponents/AirlineChip'
import BreadCrumbs from 'pageComponents/_common/BreadCrumbs'
import { Helmet } from 'react-helmet'
import { productSchema } from '../_common/richSearchSchemas/productSchema'
import { breadcrumbSchema } from '../_common/richSearchSchemas/breadcrumbSchema'
import queryString from 'query-string'
import MultiImage from 'pageComponents/_common/multiImage/MultiImage'
import ItemDetailsBase from './uiComponents/ItemDetailsBase'
import ItemDetailsInfo from './uiComponents/ItemDetailsInfo'
import ItemDetailsCustomizer from './uiComponents/ItemDetailsCustomizer'
import RequestPriceButton from 'pageComponents/_common/RequestPriceButton'
import Frequently from './uiComponents/Frequently'
import EmployeeAddButton from 'pageComponents/_common/EmployeeAddButton'
import { gtag } from 'ga-gtag';

import SkeletonItem, { Title, Detail1 as SkeletonLine } from '../SearchResults/uiComponents/skeletonItem'
import CartCheckModal from 'pageComponents/_common/modals/cartCheckModal'
import { useAirlineFetch } from 'setup/REST'

import { ShowErrorAlert } from 'styles/alerts'
import { AreaContentRow, LayoutArea } from 'pageComponents/Checkout2/styledComponents'
import { DismissModalButton } from 'setup/CheckoutProviderFields'
import Modal from 'pageComponents/_common/modal'



const ItemDetailPageContainer = styled.div`
	display: flex;
	flex-wrap: wrap;
`

const DivPhoto = styled.div`
	min-width: 200px;
	max-width: 400px;
	max-height: 400px;
	margin: 0 8px;
	text-align: center;
`

const DivPurchaseInfo = styled.div`
	position: -webkit-sticky;
	position: sticky;
	top: 125px;
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 100%;
	margin: 30px 8px 0 12px;
	padding: 8px 16px;
	box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
`

const DivLeftCol = styled.div`
	display: flex;
 	flex-direction: column;
 	max-width: 400px;
 	align-items: center;
 	padding: 0 16px;
 	margin-bottom: 16px;
`

const DivPurchaseInfoButtons = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	align-items: center;
	margin: 16px 0;
`

const Row = styled.div`
	display: flex;
	align-items: center;
`

const RowCentered = styled.div`
	display: flex;
	justify-content: center;
`

const P = styled.p`
	margin: 0;
`

const ButtonRed = styled.button`
	background-color: #b51029;
	width: 70%;
	color: white;
	font-weight: 600;
	border: 0;
	box-shadow: 1px 1px 2px #000;
	margin: 4px auto;
	padding: 4px 0;
	&:hover{
		background-color: rgb(219, 22, 51);
	}
	&:active{
		background-color: #b51029;
		box-shadow: 0 0 1px #000;
	}
`

const Pprice = styled.p`
	color: #328EFC;
	font-size: 18px;
	font-weight: 700;
    padding: 0 0 4px 4px;
	margin: 0;
`

const ACall = styled.a`
	color: #328EFC;
	font-weight: 700;
	padding: 0 4px;
`

const DivBrand = styled.div`
    display: flex;
    justify-content: flex-end;
    width: 100%;
`

const BrandContainer = styled.div`
    height: 25px;
`

const BrandImg = styled.img`
    width: 75px;
    height: 100%;
    object-fit: contain;
`

export default function ItemDetailPage(props) {

    const {
        userInfo,
        addItem,
        itemPrices: cachedPrices,
        getItemPrices,
        itemAvailabilities: cachedAvailabilities,
        customerPartNumbers,
        stockAvailabilities,
        getStocks,
        impersonatedCompanyInfo,
    } = useContext(Context)

    const { airlineGet } = useAirlineFetch()

    const { itemView } = props

    useEffect(() => {
        window.scrollTo({ top: 0 })
    }, [])

    const { itemId, customerPartNumber: param_customerPartNumber, item } = useParams();
    const [invMastUid, setInvMastUid] = useState(parseInt(itemId))
    const [accessoryItems, setAccessoryItems] = useState([])
    const [familyAccessoryItems, setFamilyAccessoryItems] = useState([])
    const [accessoryItemPrices, setAccessoryItemPrices] = useState([])
    const [accessoryItemsInfo, setAccessoryItemsInfo] = useState({})
    const [quantity, setQuantity] = useState(1)
    const [selectedCustomerPartNumberId, setSelectedCustomerPartNumberId] = useState(0)
    const [customerPartOptions, setCustomerPartOptions] = useState([])
    const [customItemType, setCustomItemType] = useState()
    const [customizerPrice, setCustomizerPrice] = useState(0)

    //If the itemId changes using useParams, without this use effect, the page wont retrieve the correct item information
    useEffect(() => {
        var newId = parseInt(itemId);
        if (newId !== invMastUid) {
            setInvMastUid(newId);
        }
    }, [itemId]);

    const cachedItemPrice = cachedPrices.find(price => price.invMastUid === invMastUid)
    const {
        unitOfMeasure,
        unitSize,
        roundType,
        unitPrice
    } = cachedItemPrice || { unitPrice: 0 }

    const [showShowAddedToCartModal, setShowAddedToCartModal] = useState(false)
    const [showAddListModal, setShowAddListModal] = useState(false)
    const [showCheckItemInOrdersOrQuotes, setShowCheckItemInOrdersOrQuotes] = useState(false)
    const [itemAddedToCart, setItemAddedToCart] = useState()
    const [itemInOrdersOrQuotes, setItemInOrdersOrQuotes] = useState([])
    const [loadedCalls, setLoadedCalls] = useState([])
    const [customizerItem, setCustomizerItem] = useState([])

    const [showAlert, setShowAlert] = useState(false)
    const [alertContent, setAlertContent] = useState(<></>) //TODO: Pull this out to Context to allow for consistent error messaging

    function handleAddedToCart(invMastUid) {
        setShowAddedToCartModal(true)
        setItemAddedToCart(invMastUid)
    }
    function handleAddedToCartModal() {
        setShowAddedToCartModal(false)
        if(itemAddedToCart && userInfo) {
            airlineGet(`/CheckForItemOnOrdersAndQuotes/${itemAddedToCart}`)
            .then(async (res) => {
                if (res.ok) {
                    return res.json();
                }
                throw new Error((await res.json())?.detail);
            })
            .then((res) => { console.log(res); setItemInOrdersOrQuotes(res) })
            .catch((res) => {
                console.log("Error checking Item added to cart", res)
                setAlertContent(<>
                    <LayoutArea>
                        <AreaContentRow>
                            <ShowErrorAlert message={res + ""} />
                        </AreaContentRow>
                    </LayoutArea>
                    <DismissModalButton onClick={()=>setShowAlert(false)} />
                </>)
                setShowAlert(true)
            })
        }
    }

    const [getItemInfo, { data: itemInfo }] = useLazyQuery(GET_ITEM_DETAIL_PAGE_ITEM_INFO, {
        variables: { invMastUid },
        fetchPolicy: 'no-cache',
        onCompleted: result => {
            const details = result.itemDetails
            if (!details) return;
            if (!cachedItemPrice) getItemPrices([details])

            //If there are accessory items attached to this item, query for their details
            if (details.associatedItems && details.associatedItems.length) {
                setAccessoryItems(details.associatedItems)
                //Family Head Item is overwritten by CutToLengthMaterial item so we need to save its accessory items separately
                if (details.itemFamilies.length > 0 && details.itemFamilies?.some(f => f.familyInvMastUid === details.invMastUid)) {
                    setFamilyAccessoryItems(details.associatedItems)
                }

                anchorLink()

                //Load stock information for the related products
                if (details.associatedItems.length) {
                    const itemsWithoutStockInfo = accessoryItem =>
                        !stockAvailabilities.some(stock => stock.invMastUid === accessoryItem.associatedInvMastUid)

                    const filteredAccessoryItems = details.associatedItems
                        .filter(itemsWithoutStockInfo)
                        .map(accessoryItem => ({ invMastUid: accessoryItem.associatedInvMastUid }))

                    if (filteredAccessoryItems.length) {
                        getStocks(filteredAccessoryItems)
                    }
                }
                //If an item is CutToLengthMaterial we don't want to get its accessoryItems
                if (!details.itemFamilies?.some(f => f.members.find(m => m.relationshipToFamily === "CutToLengthMaterial").invMastUid === details.invMastUid)) {
                    //Build the price request objects
                    const accessoryItemPriceRequests = details.associatedItems.map(i => {
                        return {
                            invMastUid: i.associatedInvMastUid,
                            quantity: 1
                        }
                    })

                    queryAccessoryItemPrices({
                        variables: {
                            items: accessoryItemPriceRequests
                        }
                    })

                    queryAccessoryItemsInfo({
                        variables: {
                            invMastUids: details.associatedItems.map(i => i.associatedInvMastUid)
                        }
                    })
                }
            } else {
                setAccessoryItems([])
            }
            setLoadedCalls(loadedCalls => [...loadedCalls, 'getItemInfo'])
        }
    })

    useEffect(() => {
        //Gathers part numbers from the context or the item info sets the selected CPN ID
        //to the first one in the list, if it is the only CPN for the item
        const distinctCPNs = []
        const map = new Map()
        for (const item of (itemInfo?.customerPartNumbers || []).concat(customerPartNumbers || [])) {
            if (!map.has(item.customerPartNumber)) {
                map.set(item.customerPartNumber, true);
                distinctCPNs.push(item)
            }
        }
        const filteredCustomerPartNumbers = distinctCPNs.filter(c => c.invMastUid === invMastUid)
        setCustomerPartOptions(filteredCustomerPartNumbers)
        if (filteredCustomerPartNumbers?.length === 1) {
            setSelectedCustomerPartNumberId(filteredCustomerPartNumbers[0].id)
        }
    }, [customerPartNumbers, invMastUid, itemInfo?.customerPartNumbers])

    useEffect(() => {
        //Choose the associted customer part number ID from the part number in the URL
        if (param_customerPartNumber) {
            setSelectedCustomerPartNumberId(customerPartOptions.find(p => p.customerPartNumber === param_customerPartNumber)?.id)
        }
    }, [userInfo, param_customerPartNumber, customerPartOptions])

    useEffect(() => {
        getItemInfo()
    }, [userInfo, invMastUid])

    const itemDetails = itemInfo?.itemDetails;
    const isDiscontinued = itemDetails?.isDiscontinued;

    //Create the canonical for this page, based on the parameters to it not the data query. (ItemId is sanitized)
    const canonItem = item.trim().replace(/[^a-zA-Z0-9]/g, '-')
    const canonUrl = itemView
        ? (itemView === 'info' ? `${process.env.REACT_APP_SITE_URL}/productinfo/${canonItem}/${itemId}` : `${process.env.REACT_APP_SITE_URL}/productcustomizer/${canonItem}/${itemId}`)
        : `${process.env.REACT_APP_SITE_URL}/product/${canonItem}/${itemId}`

    useEffect(() => {
        document.title = `${itemDetails?.itemDesc || item}${itemView ? (itemView === 'info' ? ' Bill of Materials' : ' Customizer') : ''} | Airline Hydraulics`
        anchorLink()
    }, [itemDetails, item, itemView])

    const cachedItemAvailability = cachedAvailabilities.find(avail => avail.invMastUid === invMastUid)
    const [itemAvailability, setItemAvailability] = useState()
    const [queryAccessoryItemPrices] = useLazyQuery(GET_ITEM_PRICE, {
        onCompleted: data => {
            setAccessoryItemPrices(data.getItemPrices)
            setLoadedCalls([...loadedCalls, 'getItemPrices'])
        }
    })

    const [queryAccessoryItemsInfo] = useLazyQuery(GET_ACCESSORY_ITEMS_INFO, {
        onCompleted: ({ itemAvailability, itemDetailsBatch }) => {
            setAccessoryItemsInfo({ itemAvailability, itemDetailsBatch })
            setLoadedCalls([...loadedCalls, 'queryAccessoryItemsInfo'])
        }
    })

    const handleAddToCart = () => {
        // Will need to be changed to fit future customizations
        if (customItemType === 'cut' || customItemType === 'machining') {
            addItem(customizerItem)
        }
        else {
            addItem({
                invMastUid: invMastUid,
                quantity: parseInt(quantity, 10),
                itemUnitPriceOverride: null,
                customerPartNumberId: selectedCustomerPartNumberId || 0
            })
        }
        gtag("event", "add_to_cart", {
            items: [
                {
                    item_id: itemDetails.itemCode,
                    item_name: itemDetails.itemDesc,
                    price: unitPrice
                }
            ]
        });

        setShowAddedToCartModal(true)
        setItemAddedToCart(invMastUid)
        setQuantity(1)

    }
    const categoryBreadcrumbs = itemDetails?.categoryBreadcrumbs

    useEffect(() => {
        if (customItemType !== 'cut') {
            setItemAvailability(itemInfo?.itemAvailabilitySingular || cachedItemAvailability)
        }

    }, [setItemAvailability, itemInfo?.itemAvailabilitySingular, cachedItemAvailability, customItemType])

    useEffect(() => {
        if (loadedCalls.length === 3) {
            const hash = queryString.parse(window.location.hash)
            if (Object.keys(hash).length) {
                const id = Object.keys(hash)[0]
                document.getElementById(id)?.scrollIntoView()
            }
        }
    }, [loadedCalls])

    const handleItemChange = (invMastUid) => {
        setInvMastUid(parseInt(invMastUid))
        if(!customItemType) { // Assumes that if customItemType is not already set, item is CTL
            setCustomItemType('cut')
        }
    }

    const brandSearchLink = `/search?searchTerm=${itemDetails?.brand?.name}&sortType=relevancy&nonweb=false&brands=${itemDetails?.brand?.name}&resultPage=1`
    const brandLogo = itemDetails?.brand?.media?.svgPath ?? itemDetails?.brand?.media?.imgPath;
    const brandLogoHeight = itemDetails?.brand?.media?.svgPath ? 25 : (itemDetails?.brand?.media?.imgPath ? itemDetails?.brand?.media?.imgHeight : -1);
    const brandLogoWidth = itemDetails?.brand?.media?.svgAspectRatio
        ? (itemDetails?.brand?.media?.svgAspectRatio ?? 1) * brandLogoHeight
        : itemDetails?.brand?.media?.imgWidth;

    const quantityAvailableToMake = stockAvailabilities.find(s => s.invMastUid === invMastUid)?.airlineStock?.[0]?.quantityAvailableToMake
    const restrictedCustomerIds = itemDetails?.restrictedCustomers?.map(c => c.customerIdP21)
    const customerIdP21 = impersonatedCompanyInfo?.customerIdP21 || userInfo?.companyId

    const [canAddToList, setCanAddToList] = useState(false)

    useEffect(() => {
        if (customItemType === 'cut') setCanAddToList(false) // cuts can't be added to a list
        else if (!customerIdP21) setCanAddToList(false) // a non-signed in user can't add to a list
        else if (userInfo?.isAirlineEmployee) { // employees can add to if the item is not restricted or they are in the restricted allow list
            if (restrictedCustomerIds?.length === 0) setCanAddToList(true) // if there are no restricted customers, anyone can add to a list
            else if (restrictedCustomerIds?.length > 0 && restrictedCustomerIds.includes(customerIdP21)) setCanAddToList(true) // if the customer is in the restricted allow list, they can add to a list
        } else {
            // this is a customer, who is signed in and not an employee
            setCanAddToList(itemDetails?.CurrentUserAllowed)
        }
    }, [customerIdP21, restrictedCustomerIds, customItemType])

    useEffect(() => {
        if(itemInOrdersOrQuotes.length > 0)
            setShowCheckItemInOrdersOrQuotes(true)
    }, [itemInOrdersOrQuotes])

    // TODO: Fix the placeholders and loading
    return (
        <ItemDetailPageContainer>
            {itemDetails && <Helmet>
                <title>{itemDetails?.itemDesc || item}{itemView ? (itemView === 'info' ? ' Bill of Materials' : ' Customizer') : ''} | Airline Hydraulics</title>
                <meta name="description" content={itemDetails.extendedDesc} />
                <link rel="canonical" href={canonUrl} />
                <meta httpEquiv="last-modified" content={dateFormat(zonedTimeToUtc(itemDetails.dateModified || new Date(), ''), 'EEE, dd LLL yyyy HH:mm:ss') + ' GMT'} />
                {productSchema(itemDetails, cachedItemPrice, itemAvailability)}
                {breadcrumbSchema([
                    {
                        name: itemDetails.brand?.name,
                        item: process.env.REACT_APP_SITE_URL + buildSearchString({ searchTerm: itemDetails.brand?.name })
                    },
                    {
                        name: itemDetails.itemCode
                    }
                ])}
            </Helmet>
            }

            {!itemDetails ? <SkeletonLine /> : <>
                {isDiscontinued ? (
                    <h1 style={{ textDecoration: "line-through" }}>{itemDetails?.itemDesc}</h1>
                ) : (
                    <h1>{itemDetails?.itemDesc}</h1>
                )}
            </>
            }

            {!itemDetails ? <SkeletonLine style={{ width: '100%', height: '22.5px', marginTop: '20px' }} /> : <BreadCrumbs {...{ breadCrumbTrail: categoryBreadcrumbs }} />}
            {!itemDetails ? <SkeletonItem /> :
                <DivLeftCol>
                    <DivBrand>
                        <BrandContainer>
                            <Link to={itemDetails?.brand?.brandPromoLink || brandSearchLink}>
                                {brandLogo ? (
                                    <BrandImg
                                        width={brandLogoWidth}
                                        height={brandLogoHeight}
                                        src={brandLogo}
                                        alt={itemDetails.brand.name}
                                    />
                                ) : (
                                    <div>{itemDetails?.brand?.name}</div>
                                )}

                            </Link>
                        </BrandContainer>
                    </DivBrand>
                    <DivPhoto>
                        <MultiImage size='zoom' details={itemDetails} textSize='large' />
                    </DivPhoto>
                    {isDiscontinued && <div>Item Discontinued</div>}
                    {(!isDiscontinued || userInfo?.isAirlineEmployee) && (

                        <DivPurchaseInfo>
                            {(customItemType === 'cut' || customItemType === 'machining') ?
                                <>
                                    <Row>
                                        <Pprice>{!customizerPrice ? <ACall href="tel:+18009997378">Call for Price</ACall> : `$${customizerPrice.toFixed(2)}`}</Pprice>
                                    </Row></> :
                                <>
                                    <Row>
                                        <Pprice>{!unitPrice ? <ACall href="tel:+18009997378">Call for Price</ACall> : `$${unitPrice.toFixed(2)}`}</Pprice>
                                        {!!unitPrice && <P> /{unitOfMeasure}</P>}
                                    </Row></>}
                            {
                                itemDetails && (
                                    !unitPrice
                                        ? gtag("event", "item_detail_page_call_for_price_page_view", {
                                            items: [
                                                {
                                                    item_id: itemDetails?.itemCode,
                                                    item_name: itemDetails?.itemDesc,
                                                }
                                            ]
                                        })
                                        : gtag("event", "view_item", {
                                            items: [
                                                {
                                                    item_id: itemDetails?.itemCode,
                                                    item_name: itemDetails?.itemDesc,
                                                    price: unitPrice,
                                                }
                                            ]
                                        })
                                )
                            }
                            <LocationsModal
                                invMastUid={itemDetails?.invMastUid}
                                availabilityInfo={itemAvailability}
                                unitPrice={unitPrice}
                                isAssembly={itemDetails?.isAssembly}
                            />
                            {customItemType !== 'machining' &&
                                <DivPurchaseInfoButtons>
                                    <RowCentered>
                                        <span>Qty:</span>
                                        <QuantityInput
                                            quantity={quantity}
                                            unitSize={unitSize}
                                            unitOfMeasure={unitOfMeasure}
                                            roundType={roundType}
                                            handleUpdate={setQuantity}
                                            min='0'
                                        />
                                        {(unitSize > 1) && (
                                            <AirlineChip style={{ marginLeft: '0.5rem', fontSize: '0.9rem' }}>
                                                X {unitSize}
                                            </AirlineChip>
                                        )}
                                    </RowCentered>
                                    {
                                        // no one, employee or customer, should be able to add a restrict item to a list
                                        canAddToList &&
                                        <ButtonRed onClick={() => setShowAddListModal(true)}>Add to List</ButtonRed>
                                    }

                                    {!!cachedItemPrice && (
                                        userInfo?.isAirlineEmployee &&
                                            userInfo?.isImpersonatorUser ? (
                                            <EmployeeAddButton {...{ handleAddToCart, details: itemDetails, width: '70%' }} />
                                        ) : !unitPrice || customItemType && !customizerPrice ? (
                                            <RequestPriceButton {...{ invMastUid }} />
                                        ) : (
                                            <ButtonRed onClick={handleAddToCart}>Add to Cart</ButtonRed>
                                        )
                                    )}
                                </DivPurchaseInfoButtons>
                            }
                            {!!itemDetails.itemFeatures?.length && <a className='scrollToLink' href='#feature'>Features</a>}
                            {!!itemDetails.itemTechSpecs?.length && <a className='scrollToLink' href='#techspec'>Tech Specs</a>}
                            {accessoryItems?.filter(a => a.type === 2)?.length > 0 && <a className='scrollToLink' href='#accessory'>Accessory</a>}
                            {itemDetails.hasRelations && <a className='scrollToLink' href='#relatedto'>Related To...</a>}
                        </DivPurchaseInfo>
                    )

                    }

                </DivLeftCol>
            }

            {itemView === 'info' ? (
                <ItemDetailsInfo {...{
                    accessoryItemPrices,
                    accessoryItemsInfo,
                    accessoryItems,
                    setShowAddedToCartModal,
                    quantityAvailableToMake,
                }} />) :
                (
                    itemDetails?.itemFamilies.length > 0 ?
                        <ItemDetailsCustomizer
                            {...{
                                itemDetails,
                                customItemType,
                                setCustomItemType,
                                setCustomizerPrice,
                                customizerItem,
                                setCustomizerItem,
                                itemAvailability,
                                setItemAvailability,
                                unitPrice,
                                unitOfMeasure,
                                quantity,
                                handleItemChange,
                                familyAccessoryItems,
                                accessoryItems,
                                accessoryItemsInfo,
                                accessoryItemPrices,
                                setShowAddedToCartModal,
                                invMastUid,
                                handleAddToCart
                            }}
                        /> : (
                            !itemDetails ? <SkeletonLine /> :
                                <ItemDetailsBase {...{
                                    itemDetails,
                                    accessoryItems,
                                    accessoryItemsInfo,
                                    accessoryItemPrices,
                                    itemAvailability,
                                    unitOfMeasure,
                                    unitPrice,
                                    handleAddedToCart,
                                    setSelectedCustomerPartNumberId,
                                    selectedCustomerPartNumberId,
                                    customerPartOptions,
                                    loadedCalls,
                                    invMastUid,
                                    itemInfo,
                                    brandSearchLink,
                                    quantityAvailableToMake,
                                }} />
                        ))}
            <Frequently {...{ invMastUid, setShowAddedToCartModal, handleAddedToCart }} />
            <AddedModal
                open={showShowAddedToCartModal}
                text="Added to Cart!"
                onClose={handleAddedToCartModal}
                timeout={900}
            />
            <CartCheckModal 
                open={showCheckItemInOrdersOrQuotes}
                onClose={() => setShowCheckItemInOrdersOrQuotes(false)}
                item={itemAddedToCart}
                details={itemInOrdersOrQuotes}
            />
            <Modal open={showAlert} onClose={() => setShowAlert(false)}>
                {alertContent}
            </Modal>

            {userInfo && (
                <AddToShoppingListModal
                    open={showAddListModal}
                    hide={() => setShowAddListModal(false)}
                    item={itemDetails}
                    customerPartNumberId={selectedCustomerPartNumberId}
                    defaultQuantity={quantity}
                />
            )}
        </ItemDetailPageContainer>
    )
}
